<div class="header-wrapper">
  <div class="container-wrapper">
    <div class="d-flex justify-content-between">
      <img aria-label="Go Back" src="https://images.5paisa.com/forum/icon-left-arrow.svg" (click)="goBack()" />
      <h1 class="m-0 font-16 fw-500">Support</h1>
      <div class="header-image-wrapper">
        <img *ngIf="isLoggedIn == 'Y'" aria-label="View Ticket" (click)="goToViewTicket()" src="https://images.5paisa.com/forum/icon-ticket.png" />
        <img class="d-none" src="https://images.5paisa.com/forum/icon-language.png" />
      </div>
    </div>
  </div>
</div>